import { BugList } from "./BugList";

/** One project's bugs. The same table the organisation-wide page shows, scoped to here. */
export function ProjectBugsTab({ projectId }: { projectId: string }) {
  return <BugList projectId={projectId} />;
}
